// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".priority-container[data-v-8baa11e6] {\n  padding: 16px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
